import React from 'react';
import CoreSvg from 'shared/CoreSvg';
import Icon from 'shared/icons';
import { FilterLargeChips, LeftIconWrapper } from './style';
import { IFilterChips } from './type';
import { useTheme } from 'styled-components';

const FilterButton = ({
	value,
	selected,
	setSelected,
	_width,
	_disabled = false,
	flex = 'center',
}: IFilterChips) => {
	const theme = useTheme();
	return (
		<>
			<FilterLargeChips
				selected={selected === value || selected.includes(value)}
				disabled={_disabled}
				_width={_width}
				onClick={() => {
					setSelected && setSelected(value);
				}}
				flex={flex}
			>
				{!_disabled && (selected === value || selected.includes(value)) && (
					<LeftIconWrapper>
						<CoreSvg _fill={theme.colors.primary.primary80_darken}>
							<Icon.Check />
						</CoreSvg>
					</LeftIconWrapper>
				)}
				{value}
			</FilterLargeChips>
		</>
	);
};

export default FilterButton;
